module.exports = __webpack_public_path__ + "media/images/game/pages/logo_fin_gram-782cbf1d8bf75401aacc747b1f0f9c07.png";